<template>
    <div>
        <Head>
            <title>Корзина</title>
        </Head>
        <Header pageName="Корзина" :cart-count="$page.props.cartCount"/>
        <div class="mx-auto max-w-2xl px-4 py-4 sm:px-6 sm:py-8 lg:max-w-7xl relative">
            <div class="grid points-main-wrapper">
                <div class="mb-4">
                    <div class="flex">
                        <h2 class="page-title"> Оформлення замовлення</h2>
                    </div>
                </div>
                <div class="cart-item py-4" v-for="(item, index) in form.items" :key="index">
                    <div class="item-details flex justify-between items-start pb-8 border-b-2">
                        <div>
                            <h3 class="text-xl font-semibold">{{ item.name }}</h3>
                            <p class="text-sm text-gray-600">{{ item.attributes.date }}</p>
                            <p class="text-sm text-gray-600">Тариф: {{ item.attributes.category_name }}</p>
                            <p class="text-sm text-gray-600">Опис тарифа: {{ item.attributes.category_description }}</p>
                            <p class="text-sm text-gray-600">Час заїзду: {{ item.attributes.type_name }}</p>
                            <div class="flex items-center mt-6">
                                <text-input
                                    v-if="priceDependOnPeopleCount(item)"
                                    v-model="item.attributes.quantity"
                                    type="number"
                                    min="1"
                                    max="99"
                                    :error="form.errors.quantity"
                                    class="w-full cart-people-quantity"
                                    label="Кількість людей"
                                    @input="updateCart(index)"
                                />
                            </div>
                            <p class="mt-4 text-l text-gray-600"><b>Ціна:</b> {{ item.price }} грн</p>
                        </div>
                        <div>
                            <button
                                class="items-center h-12 btn-indigo uppercase tracking-widest text-uppercase rounded-lg justify-center btn-delete-from-cart"
                                @click="removeFromCart(item.id, index)">
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <p class="text-2xl"><b>Всього:</b> {{ total }} грн</p>
                </div>
                <div class="mt-8 w-full lg:w-1/4">
                    <div class="mb-4">
                        <label for="name" class="block text-sm font-medium text-gray-700">Імʼя</label>
                        <input type="text" id="name" v-model="form.name" maxlength="25"
                               class="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm p-2">
                        <div v-if="form.errors.name" class="form-error">{{ form.errors.name }}</div>
                    </div>
                    <div class="mb-4">
                        <label for="phone" class="block text-sm font-medium text-gray-700">Телефон</label>
                        <input type="tel" id="phone" v-model="form.phone" min="9"
                               class="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm p-2"
                        >
                        <div v-if="form.errors.phone" class="form-error">{{ form.errors.phone }}</div>
                    </div>
                </div>
                <div class="flex" :class="isWatchman ? 'justify-between' : 'justify-end'">
                    <loading-button
                        v-if="isWatchman"
                        class="items-center h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                        :loading="loading"
                        @click="checkoutByCash"
                    >
                        Провести оплату
                    </loading-button>
                    <loading-button
                        class="items-center h-12 btn-indigo uppercase tracking-widest btn-booking text-uppercase rounded-lg justify-center"
                        :loading="loading"
                        @click="checkout"
                    >
                        Сплатити
                    </loading-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue3'
import Header from "@/Component/Header"
import {useToast} from "vue-toastify"
import TextInput from "@/Shared/TextInput"
import {debounce} from "lodash"
import LoadingButton from "@/Shared/LoadingButton.vue";

export default {
    components: {
        LoadingButton,
        TextInput,
        Header,
        Head,
    },
    props: {
        cartItems: Object,
        total: Number,
        user: Object
    },
    data() {
        return {
            form: this.$inertia.form({
                items: Object.values(this.cartItems).map(item => ({
                    ...item
                })),
                name: this.user ? this.user.first_name : '',
                phone: this.user ? this.user.phone_number : '',
                errors: {
                    phone: ''
                }
            }),
            toast: null,
            cartCount: 0,
            loading: false
        };
    },
    computed: {
        isWatchman() {
            return this.user && (this.user.watchman || this.user.owner)
        }
    },
    methods: {
        priceDependOnPeopleCount(item) {
            return !!item.attributes.is_price_depend_on_people_count
        },
        validatePhone() {
            if (this.form.phone.length < 9) {
                this.form.errors.phone = 'Номер телефону має бути не меньш ніж 9 символів';
                return false;
            }
            this.form.errors.phone = '';
            return true;
        },
        updateCart: debounce(function (index) {
            if (this.form.items[index].attributes.quantity < 1) {
                return this.form.items[index].attributes.quantity = 1
            }
            this.form.put(this.$route('cart.update'))
        }, 200),
        removeFromCart(itemId, index) {
            this.form.items.splice(index, 1);
            this.form.delete(this.$route('cart.remove', itemId))
        },
        checkout() {
            this.loading = true;
            if (this.validatePhone()) {
                this.form.post(this.$route('book.points'), {
                    onFinish: () => {
                        this.loading = false;
                    }
                });
            } else {
                this.loading = false;
            }
        },

        checkoutByCash() {
            this.loading = true
            if (this.validatePhone()) {
                this.form.post(this.$route('book.points.cash'), {
                    onFinish: () => {
                        this.loading = false;
                    }
                });
            } else {
                this.loading = false;
            }
        }
    },
    mounted() {
        this.toast = useToast()
    }
}
</script>
